import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import useDynamicFontSize from '../../hooks/useDynamicFontSize';

const ScalableText = props => {
    const [scalableStyle, setScalableStyle] = useState();
    const { calculateFontSize } = useDynamicFontSize();
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            const fontSize = calculateFontSize(props.fontSize || Styles.scalableText.fontSize);
            const lineHeight = isNaN(Math.floor(fontSize * 1.3)) ? undefined : Math.floor(fontSize * 1.3);

            setScalableStyle({
                fontSize,
                lineHeight
            });
        }
    }, [ref, props.fontSize, calculateFontSize]);

    return (
        <Text {...props} ref={ref} style={StyleSheet.flatten([Styles.scalableText, props.style, scalableStyle])}>
            {props.children}
        </Text>
    );
};

export default ScalableText;

const Styles = StyleSheet.create({
    scalableText: {
        fontFamily: 'GothamBook',
        fontSize: 16
    }
});

ScalableText.propTypes = {
    fontSize: PropTypes.number,
    length: PropTypes.number,
    style: PropTypes.object
};
